import React from 'react';
import { motion } from 'framer-motion'; // Importing framer-motion

import './SingleBlog.css';

function SingleBlog({ theme, title, desc, date, image, url, id }) {
    return (
        // Using motion.a instead of regular a for animation
        <motion.a
            className="singleBlog"
            key={id}
            href={url}
            target="_blank"
            rel="noreferrer"
            style={{ backgroundColor: theme.primary400 }}
            initial={{ opacity: 0 }} // Initial state: hidden
            animate={{ opacity: 1 }} // Animate to visible
            transition={{ duration: 0.5 }} // Transition duration
        >
            <div className="singleBlog--image" style={{ backgroundColor: theme.secondary }}>
            {image && <img src={image} alt={title} />}
            </div>
            <div className="singleBlog--body">
                <p style={{ color: theme.tertiary }}>{date}</p>
                <h3 style={{ color: theme.secondary }}>{title}</h3>
                <h6 style={{ color: theme.secondary }}>{desc}</h6>
            </div>
        </motion.a>
    );
}

export default SingleBlog;
